import { render, staticRenderFns } from "./ConfirmarReactivar.vue?vue&type=template&id=6570d01c&scoped=true&"
import script from "./ConfirmarReactivar.vue?vue&type=script&lang=js&"
export * from "./ConfirmarReactivar.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarReactivar.vue?vue&type=style&index=0&id=6570d01c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570d01c",
  null
  
)

export default component.exports